import React from 'react';

import {linkLocations, namedEvents} from '../../utils/edap';

import {Dropdown} from '@homeaway/react-dropdown';
import {SVGIcon} from '@homeaway/react-svg';
import {CHEVRON_DOWN__16, PERSON__24} from '@homeaway/svg-defs';
import {clickedOnTravelerLogin, clickedOnOwnerLogin} from '../../utils/login.utils';
import {TrackingContext} from '@homeaway/react-event-tracking';


const loginRE = /(def%26service%3D){1}(.*\.com)?.*/;

export class Login extends React.Component {
    static contextType = TrackingContext;

    edapTrigger = (item) => {
        let actionLocation = linkLocations.HEADER_LINK_LOGIN; // default
        if (clickedOnTravelerLogin(item.cssClass) || clickedOnOwnerLogin(item.cssClass)) {
            actionLocation = clickedOnTravelerLogin(item.cssClass) ? linkLocations.HEADER_LINK_TRAVELER_LOGIN : linkLocations.HEADER_LINK_OWNER_LOGIN;
        }
        const eventField = {
            actionlocation: actionLocation
        };
        this.context.trigger(namedEvents.HEADER_LINK_CLICK, eventField);
    }

    handleLoginClick = () => {
        this.edapTrigger({});
    }

    createLoginHandler = (item) => {
        return (event) => {
            if (!item.link) {
                return;
            }
            this.edapTrigger(item);

            const didClickOnTravelerLogin = clickedOnTravelerLogin(item.cssClass);
            if (this.props.travelerLoginClickHandler && didClickOnTravelerLogin) {
                event.stopPropagation();
                event.preventDefault();
                this.props.travelerLoginClickHandler();
                return;
            }

            // CAS Login URLs need to be double encoded because of how their params are structured:
            // https://{DOMAIN}/auth/traveler/login?service=https://{DOMAIN}/exp/sso/auth?lt=traveler&context=def&service={DOUBLE_ENCODED_RETURN_URL}&kmsi=true
            let doubleEncodedURI = encodeURIComponent(encodeURIComponent(window.location.pathname + window.location.search));

            // if login, perform specific link update
            let newLink = item.link.replace(
                loginRE,
                `$1${doubleEncodedURI}&kmsi=true`
            );

            // if we generate a new link, user has navigated to a sub URL in the same application
            // and we should redirect them there.  Otherwise let default user-agent behavior handle
            // rendered link
            if (newLink !== item.link) {
                event.stopPropagation();
                event.preventDefault();
                window.location.assign(newLink);
            }
        };
    }

    render() {
        if (!this.props.items) {
            return null;
        }

        let {items, label} = this.props;
        let id = 'site-header__login';

        // NOTE:
        // This allows for testing login functionality locally, as the link url
        // provided by the service redirects to stage.homeaway.com rather than
        // to localhost.
        // NOTE: For development / test
        // items[0].link = 'https://cas-test.homeaway.com/auth/traveler/login?service=http%3A%2F%2Flocalhost:8080%2Fexp%2Fsso%2Fauth%3Flt%3Dtraveler%26context%3Ddef%26service%3D%252F&kmsi=true';
        // NOTE: For stage
        // items[0].link = 'https://cas-stage.homeaway.com/auth/traveler/login?service=http%3A%2F%2Flocalhost:8080%2Fexp%2Fsso%2Fauth%3Flt%3Dtraveler%26context%3Ddef%26service%3D%252F&kmsi=true';


        let toggle = (
            <button
                aria-expanded="false"
                aria-haspopup="true"
                className="site-header-nav__toggle Dropdown__toggle"
                id={id}
            >
                <SVGIcon inlineFlex markup={PERSON__24}/><span className="site-header-nav__icon-label">{label}</span><SVGIcon className="Dropdown__toggle-icon" inlineFlex markup={CHEVRON_DOWN__16}/>
            </button>
        );

        return (
            <Dropdown className="site-header-nav__dropdown" customToggle={toggle} dropdownRight id={id} label={label} onDropdownShow={this.handleLoginClick}>
                {items.map((item, index) => (
                    <li key={index} role={'presentation'}>
                        <a className={item.cssClass} data-bypass="true" href={item.link} onClick={this.createLoginHandler(item)} role={'menuitem'} rel="nofollow">{item.text}</a>
                    </li>
                ))}
            </Dropdown>
        );
    }
}
